/* LISTA DE MENSAJES DE ERROR */
export const errorMessages = ["Lo sentimos, estamos teniendo problemas. Por favor, ponte en contacto con nuestro equipo de soporte para obtener ayuda.", "No hay datos disponibles para mostrar en este momento."];
